import request from '@/utils/request';

export function getStoreInfo() {
  return request('/user/store', {
    method: 'GET',
    // data: values,
  });
}

//会员详情mock
export function getMemberDetail(values) {
  const { memberID, memberCode, mobile } = values || {};
  return request('/ec/member/queryMemberInfo', {
    method: 'POST',
    data: {
      id: memberID,
      memberCode,
      mobile,
    },
  });
}
